import { SVGProps, Ref, forwardRef } from 'react';

export const BuildingFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 24H8v-.002c-3.114-.01-4.765-.107-5.828-1.17C1 21.657 1 19.771 1 16V0h13zM4 17.6v1.8h2.6v-1.8zm4.4 0v1.8H11v-1.8zM4 14.1v1.8h2.6v-1.8zm4.4 0v1.8H11v-1.8zM4 10.6v1.8h2.6v-1.8zm4.4 0v1.8H11v-1.8zM4 7.1v1.8h2.6V7.1zm4.4 0v1.8H11V7.1zM4 3.6v1.8h2.6V3.6zm4.4 0v1.8H11V3.6z"
            fill="currentColor"
        />
        <path
            d="M23 16c0 3.771 0 5.657-1.172 6.828-1.025 1.025-2.596 1.154-5.5 1.17H15.8V18.4h4.7v-1.8h-4.7v-1.7h4.7v-1.8h-4.7v-1.7h4.7V9.6h-4.7V7H23z"
            fill="currentColor"
        />
    </svg>
));
BuildingFilledSize24Glyph.displayName = 'BuildingFilledSize24Glyph';
